"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discardUploadRecord = discardUploadRecord;
var file_1 = require("../features/apis/file");
var discarded_upload_retries_1 = require("./discarded-upload-retries");
function isRetryableDeleteError(deleteError) {
    if (typeof deleteError !== "object" || deleteError === null || !("status" in deleteError)) {
        return true;
    }
    var status = deleteError.status;
    if (typeof status === "number") {
        return status === 409 || status >= 500;
    }
    return status === "FETCH_ERROR" || status === "TIMEOUT_ERROR";
}
/**
 * Discards an upload nobody activated. The API only deletes it while it is still pending, so a completion that
 * succeeded but whose response was lost keeps its file. A record whose stored object could not be removed answers 503,
 * so the same discard is retried with backoff until it succeeds or fails in a way a retry cannot fix.
 */
function discardUploadRecord(dispatch, fileId, attempt) {
    if (attempt === void 0) { attempt = 0; }
    var RETRY_DELAYS_MS = [2000, 10000, 30000, 60000, 120000];
    if (attempt === 0 && discarded_upload_retries_1.scheduledRetries.has(fileId))
        return;
    var generation = (0, discarded_upload_retries_1.getSessionGeneration)();
    dispatch(file_1.fileApi.endpoints.discardPendingUpload.initiate(fileId))
        .unwrap()
        .then(function () {
        discarded_upload_retries_1.scheduledRetries.delete(fileId);
    })
        .catch(function (deleteError) {
        if (generation !== (0, discarded_upload_retries_1.getSessionGeneration)())
            return;
        var retryDelay = RETRY_DELAYS_MS[attempt];
        if (retryDelay === undefined || !isRetryableDeleteError(deleteError)) {
            discarded_upload_retries_1.scheduledRetries.delete(fileId);
            console.error("Gave up discarding pending upload ".concat(fileId, ":"), deleteError);
            return;
        }
        discarded_upload_retries_1.scheduledRetries.set(fileId, setTimeout(function () { return discardUploadRecord(dispatch, fileId, attempt + 1); }, retryDelay));
    });
}
